import { IqBoostPrompt } from '@maximizer/ai/data-access';
import { IqPromptSelection } from '../models/iq-boost';

export function toCatalogPromptSelection(
  prompt: IqBoostPrompt,
): IqPromptSelection {
  return {
    name: prompt.name,
    title: prompt.title,
    isEmailAssist: false,
    isDraft: false,
  };
}
